import { get, publicGet } from './_httpClient';

export async function getBatchOptions({ programId = null }) {
  const { status, message, data } = await get(`/batch-options?programId=${programId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getBatchOptionsByInstitutionsId({ institutionsId }) {
  const { status, message, data } = await get(`/batch-options/institution/${institutionsId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getBatchOptionsMentors({ programId }) {
  const { status, message, data } = await get(`/batch-options/mentor?programId=${programId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getRecommendationsLetter({
  page = 1,
  pageSize = 10,
  recommendationStatusId = 3,
}) {
  const { status, message, data } = await get(
    `/clp/recommendation-letter?page=${page}&pageSize=${pageSize}&recommendationStatusId=${recommendationStatusId}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getFinalEvaluationsById({ id }) {
  const { status, message, data } = await publicGet(`/clp/public/evaluations-final/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getAlumniOptions({ q, page = 1, pageSize = 10 }) {
  const { status, message, data } = await publicGet(
    `/clp/registrations/alumni-options?q=${q}&page=${page}&pageSize=${pageSize}`
  );
  if (status !== 'success') throw new Error(message);
  return data;
}
